module.exports = __webpack_public_path__ + "static/media/unwanted-car-buyers-brisbane.d5cf3c37.png";